import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

interface ResponsiveQueries {
  isSmallMobile: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isLaptop: boolean;
  isSmallDesktop: boolean;
  isDesktop: boolean;
  isLargeDesktop: boolean;
}

const useResponsiveQueries = (): ResponsiveQueries => {
  const [mounted, setMounted] = useState(false);

  const smallMobileQuery = useMediaQuery({ maxWidth: 500 });
  const mobileQuery = useMediaQuery({ maxWidth: 768 });
  const tabletQuery = useMediaQuery({ maxWidth: 1024 });
  const laptopQuery = useMediaQuery({ maxWidth: 1200 });
  const smallDesktopQuery = useMediaQuery({ maxWidth: 1400 });
  const desktopQuery = useMediaQuery({ maxWidth: 1440 });
  const largeDesktopQuery = useMediaQuery({ maxWidth: 1620 });

  useEffect(() => {
    setMounted(true);
  }, []);

  const isSmallMobile = mounted && smallMobileQuery;
  const isMobile = mounted && mobileQuery;
  const isTablet = mounted && tabletQuery;
  const isLaptop = mounted && laptopQuery;
  const isSmallDesktop = mounted && smallDesktopQuery;
  const isDesktop = mounted && desktopQuery;
  const isLargeDesktop = mounted && largeDesktopQuery;

  return {
    isSmallMobile,
    isMobile,
    isTablet,
    isLaptop,
    isSmallDesktop,
    isDesktop,
    isLargeDesktop,
  };
};

export default useResponsiveQueries;
